import Crud from './crud'

export default class SiteContractService extends Crud {
  constructor (siteId) {
    super(`/site/${siteId}/contract`)
  }
}
